import { gql } from '@apollo/client';

export const fetchBillingProfilesForTransactionAccountInPPC = gql`
  query fetchBillingProfilesForTransactionAccountInPPC(
    $id: ID!
    $searchOptions: ConnectionSearchOptions
    $refetchDefaultPaymentMethod: Boolean = true
    $filterOptions: [FilterOption]
    $fetchNodes: Boolean = true
  ) {
    transactionAccount(id: $id) {
      id
      billingProfiles(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes @include(if: $fetchNodes) {
          id
          name
          currency
          transactionAccountId
          isActive
          invoiceGroupNumber
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            country
            state
            phone
            postcode
            taxId
            taxIds {
              id
              label
            }
            taxLabels {
              region
              taxIdLabels {
                description
                displayName
                type
              }
            }
          }
          defaultPaymentMethod(refetchDefaultPaymentMethod: $refetchDefaultPaymentMethod) {
            id
            type
            paymentIssue
            default
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
                payOnStatement
              }
            }
            ... on PayPal {
              payPal {
                email
                name
              }
            }
            ... on Ach {
              ach {
                bankName
                last4
              }
            }
          }
          shipToPriceEligibility
          purchaseOrder {
            number
            oneTimeUse
          }
          numberOfCloudsites
          numberOfSubscriptions
          createdAt
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
